import React, { useEffect, useRef, useState } from 'react'
import './Details.scss'
import Navbar from '../mininavbar/Navbar'
import axios from 'axios'
import { Baseurl } from '../../constants/env'
import { Link, useLocation, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/esm/Button'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"; 
import Searchbar from '../searchbar/Searchbar'
import Tempfooter from '../Tempfooter'
import { useSelector, useDispatch} from 'react-redux' 
import { cartItem } from '../../features/cartdata';
import { useSnackbar } from 'notistack';
import { setuserdata } from '../../features/auth'
import { StarIcon } from 'lucide-react';
// import QuillTextDisplay from '../common/QuillTextDisplay'

const Details = () => {
    const dispatch = useDispatch();
    const [showCategory, setShowCategory] = useState(false);
    const [categ, setCateg] = useState([]);
    const [searchCategory, setSearchCat] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemSet, setSelectedItemSet] = useState(new Set());
    const [data, setData] = useState([]);
    const [related, setRelated] = useState([]);
    const [cartcount, setCartCount] = useState(1);
    const [clonedata, setcloneData] = useState(true);
    const [regionprice, setRegionprice] = useState([]);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [previousSelectedPrice, setPreviousSelectedPrice] = useState(null);

  const { id } = useParams();
  const [focusimage,setFocusimage] = useState()
const location = useLocation()
  const {userlogedin} = useSelector((state)=>state.auth);
  const {userid, userdata} = useSelector((state)=>state.auth);
  const{enqueueSnackbar} = useSnackbar();
  const [reviews, setReviews] = useState([]);
  const [totalprice, setTotalprice] = useState();
  const [whatsaap, setWhatsaap] = useState();

  const regionPriceHandler = async () => {
    let res = await axios(`${Baseurl}/emirate`,{ withCredentials: true })
    console.log(res,'res');
    setRegionprice(res?.data)
    
  }
      async function getprodutsdata() {
        let productData = await axios(`${Baseurl}/products/${id}`)
        setData(productData?.data?.data)
        setcloneData(productData?.data?.data)
        console.log(productData?.data?.data,'productData?.data?.data');
        
        setTotalprice(productData?.data?.data?.[0]?.ourprice || productData?.data?.data?.[0]?.mrpprice)
        setFocusimage(`${Baseurl}/view/imageupload/${productData?.data?.data[0].img}`)
        let cat = await axios(`${Baseurl}/category`)
        setCateg(cat.data.data)

        await axios(`${Baseurl}/products`, {
          withCredentials: true,
        })
          .then((resp) => {
            setRelated(resp.data.data);
          })
          .catch((e) => {
            console.log(e.message);
          });
      }

     const getreviews = async  (sign) => {
      if(sign === 'det'){
        let review = await axios(`${Baseurl}/reviews/product/${id}`)
        if(review){
          setReviews(review?.data)
        }
        return
      }
        let review = await axios(`${Baseurl}/reviews/product/${sign}`)
        if(review){
          setReviews(review?.data)
        }
      
     }

     
  
      const detailPage = async (id) => {
        let productData = await axios(`${Baseurl}/products/${id}`)
        setFocusimage(`${Baseurl}/view/imageupload/${productData?.data?.data[0].img}`)
        setData(productData?.data?.data)
        setcloneData(productData?.data?.data)
        await getreviews(id)
      }

      async function cartdata(itemid,isActive){
        if(!userlogedin){
          return enqueueSnackbar('Login to use Cart',{variant:'error'})
        }
        if(isActive === false){
          return enqueueSnackbar('Product Inactive or Out of stock',{variant:'error'})
        }
        let data = {
         username:userid,
         products:itemid,
         totalamount :totalprice
       }
      await axios.post(`${Baseurl}/cart`,data ,{ withCredentials: true }).then((resp)=>{
       //console.log(resp );
          dispatch(cartItem(resp.data.cartlength));     
          localStorage.setItem('cart',resp.data.cartlength)     
      // setcartResp(resp);
       if(resp.status === 200){
         return enqueueSnackbar('New Item Added To The Cart',{variant:'success'})
       }
       }).catch((err)=>{
       console.log(err);
       enqueueSnackbar(err,{variant:'error'})
      });
     }

     const handleChange = (event) => {
      const selectedProduct = regionprice.find(
        (product) => product.name === event.target.value
      );
      setSelectedPrice(selectedProduct ? selectedProduct.price : null);
      //setPreviousSelectedPrice(selectedProduct.price)
    };

     async function addWish(itemid){
      if(!userlogedin){
        return enqueueSnackbar('Login to add wishlist',{variant:'error'})
      }
      let data = {
       userid,
       productId:itemid
     }
    await axios.patch(`${Baseurl}/wishlist`,data ,{ withCredentials: true }).then((resp)=>{
    // dispatch(cartItem(resp.data.cartlength));          
    // setcartResp(resp);
     if(resp.status === 200){
      dispatch(setuserdata(true))
       dispatch(setuserdata(resp.data.userdata))
       localStorage.setItem('userdata',resp.data.cartlength)
       setData(clonedata)
       return enqueueSnackbar('Product removed from wishlist',{variant:'success'})
     }
     if(resp.status === 201){
      dispatch(setuserdata(true))
      dispatch(setuserdata(resp.data.userdata))
      localStorage.setItem('userdata',resp.data.cartlength)
      setData(clonedata)
      return enqueueSnackbar('Product added to wishlist',{variant:'success'})
    }
     }).catch((err)=>{
     console.log(err);
     enqueueSnackbar(err,{variant:'error'})
    });
   }

   function whatsappEnquiry(product){
    const Number = whatsaap;
    const message = `Hello, I'm interested in ${product}.`;
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${Number}?text=${encodedMessage}`;
   }

   const handleAssemble = async (event, price) => {
    const { checked } = event.target;
      if (checked) {
        setTotalprice(totalprice + price)
      } else {
        setTotalprice(totalprice - price)
      }
   }

  useEffect(() => {
    getprodutsdata()
    getreviews('det')
    regionPriceHandler()
  }, []);

  useEffect( () => {
    if(location.pathname.includes('/prod')){
       detailPage(id)
    }
   }, [id]);
   
   useEffect(() => {
    if (previousSelectedPrice === null) {
      setTotalprice((prevTotal) => prevTotal + selectedPrice);
    } else {
      setTotalprice((prevTotal) => prevTotal - previousSelectedPrice + selectedPrice);
    }
    setPreviousSelectedPrice(selectedPrice);
  }, [selectedPrice]); 

  function setWhatsaapNumber(number){
    console.log(number,'number');
    
    setWhatsaap(number)
  }
  return (
    <>
    <main className='main'>
    <section className='section-inner-page'>
      <div className='container'>

        <div className='widget-block'>
        <div className='row'>
            <div className='col-sm-5'>
          {/* <div>set for link</div> */}

         <div className='product-lg-img-box'>

              <div className='pb-md-2'>{
                data.map((item,index) => {
                  return(
                  <div key={index}>
                    {<div> <img style={{width:'100%', height:'550px'}} src={focusimage} alt='t' /> </div> }
                  
                  <div className='w-100 text-center p-md-1 text-white'>
                  { item.type === 'old' ? 'OLD' :''}
                  { item.type === 'refurb' ? 'REFURBMISHED' :''}
                  { item.type === 'brandnew' ? 'BRAND NEW' :''}
                  </div>
                  </div>)
                })
              }</div>
              </div>

<div className='product-thumb-container d-flex mt-3'>

  <ul>
    <li>
      { data[0]?.subimg1 === 'undefined' ? <></> : <Link className='active'><img style={{width:'60px',height:'60px'}} src={`${Baseurl}/view/imageupload/${data[0]?.subimg1}`} onClick={() => setFocusimage(`${Baseurl}/view/imageupload/${data[0].subimg1}`)} class="img-fluid " alt="image" /> 
      </Link>  }
    </li>
    <li>
     {data[0]?.subimg2 === 'undefined' ? <></> : <Link className='active'><img style={{width:'60px',height:'60px'}}  src={`${Baseurl}/view/imageupload/${data[0]?.subimg2}`} onClick={() => setFocusimage(`${Baseurl}/view/imageupload/${data[0].subimg2}`)} class="img-fluid " alt="image" /> 
      </Link>  }
    </li>
    { data[0]?.subimg3 === 'undefined' ? <></> :
     <li>
      <Link className='active'> <img style={{width:'60px',height:'60px'}}  src={` ${Baseurl}/view/imageupload/${data?.[0]?.subimg3}`} onClick={() => setFocusimage(`${Baseurl}/view/imageupload/${data[0].subimg3}`)} class="img-fluid " alt="image" /> 
      </Link> 
    </li> }
    <li>
      {data[0]?.img ? <Link className='active'><img style={{width:'60px',height:'60px'}}  src={`${Baseurl}/view/imageupload/${data[0]?.img}`} onClick={() => setFocusimage(`${Baseurl}/view/imageupload/${data[0].img}`)} class="img-fluid " alt="image" /> 
      </Link> : <></> }
    </li>
    
    {/* <li>
      <a>              <img src="/images/product/thumb-oven-img.png" class="img-fluid " alt="image" /> 
      </a>
    </li>
    <li>
      <a>              <img src="/images/product/thumb-oven-img.png" class="img-fluid " alt="image" /> 
      </a>
    </li> */}
  </ul>




              </div>


            </div>
            <div className='col-sm-7 '>

              <div className='right-detail-page position-relative'>
            <div className='d-flex h-100 '>{
                data.map((item,index) => {
                  return(
                  <div key={index}>
 <Link onClick={(e)=>{addWish(item._id)}} className='btn-wishlist'>
 {userdata?.wishlist?.some(itm => itm == item._id) ? <i class="bi bi-heart-fill"></i>  :  <i class="bi bi-heart"></i>}

 </Link>

<span className='text-success stock-text'><i  class="bi bi-check"></i>
 {item?.isActive === true ? "In Stock" : "Item Inactive"}</span>
                    <div> <span className='product-name'>{item.name} </span> </div> 
                    

                    <div className='mt-2 mb-3'>
<span class="ratings mb-2 mt-1">
{[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item?.averageRating || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))}     
{`${Number.isInteger(item?.averageRating) ? item?.averageRating + '.0' : item?.averageRating}`}
</span> 
 <span className='text-danger'>• </span>  <span className='text-muted'>{item.averageRating? <></>: 'Buy and First to review' }</span> <span className='text-success'>{item?.transportationtype}</span> 
</div>







                    <div> <span className='our-price'>AED {item.ourprice} </span> <span className='mrp-price'>AED {item.ourprice} </span> <spa className="text-warning sold-text ms-2">3 products Sold in Last Weeks</spa> </div> 
                    <div>

                      <hr/>


                      {/* <p> <QuillTextDisplay text={item.description} /> </p> */}
                      {/* <p>Product Specifications:</p> */}
                      <div className='product-specification'>
                      <ul>
                       
                       <li>Category : {item.category.name}</li>
                       <li>Brand: {item.brand.name}</li>
                       </ul>
                       </div>
                       <div>
                        {item?.assembleCharge ? <span>
                          <div className='form-check'>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
            className='form-check-input'
              type="checkbox"
              onChange={(event) => {handleAssemble(event,item?.assembleCharge )}}
              style={{ marginRight: '8px' }}
            />
           Assemble Charge {item?.assembleCharge }
          </label>

        </div>
                        </span> : <></>}
                       </div>
                    </div>
                   
                    <div className='mt-4'>
                      <Button className='btn btn-dark' onClick={()=> {setCartCount(prevCount => prevCount > 0 ? prevCount - 1 : 0)}} >-</Button>
                      <span className='quantity-count'>{cartcount}</span> 
                      <Button className='btn btn-dark' onClick={()=>setCartCount(prevCount => prevCount + 1)}>+</Button>
                     
                      <hr/>
                     <div>
      <select onChange={handleChange}>
        <option value="">Select Region</option>
        {regionprice.map((product) => (
          <option key={product.name} value={product.name}>
            {product.name} - ₹{product.price}
          </option>
        ))}
      </select>
      {selectedPrice !== null && (
        <p>Selected Price: ₹{selectedPrice}</p>
      )}
    </div>
                      <div className='mt-3 our-price text-theme '>Payable Price:<span className='fw-bold ms-2'>AED {cartcount > 0 ?  totalprice * cartcount : totalprice }</span> </div>
                      <div className='mt-5'>
                     <Button className='btn btn-primary-theme me-2 w-auto' onClick={(e)=>{cartdata(item._id , item?.isActive)}}> <i class="bi bi-bag"></i> Add to Cart</Button>
                     {/* <Button className='btn-outline-primary-theme me-2' onClick={(e)=>{cartdata(item._id)}}>Buy Now</Button> */}
                     <Button target="_blank" href={ whatsappEnquiry(item.name) } className='btn-whatsap'> <i class="bi bi-whatsapp me-1"></i>
                      Enquiry with WhatsApp </Button>


                    {/* <Button className='btn btn-primary-theme w-auto' onClick={(e)=>{addWish(item._id)}}>
                      {userdata?.wishlist?.some(itm => itm == item._id) ? 'Remove from Wish'  : 'Add to Wishlist'}</Button> */}



                    </div>
                    </div>
                  </div>)
                })
              }</div>
            </div></div>
        </div> </div>

        
<div className='widget-block p-0 product-details-tab'> 

<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link active" data-bs-toggle="tab" href="#home">Description</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" data-bs-toggle="tab" href="#menu1">Reviews</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" data-bs-toggle="tab" href="#menu2">Shipping</a>
  </li>
</ul>


<div class="tab-content p-4">


  <div class="tab-pane container active" id="home">

{/* <p> <QuillTextDisplay text={data[0]?.description} /> </p> */}

<div className='row'>
<div className='col-md-6'>


<table class="table table-bordered custom-table">
    <tbody>
    {data[0]?.specs?.map((item,index) => (
      <tr key={index}>
        <th scope="row" width="200">{item?.heading}</th>
        <td>{item?.value}</td>
      </tr>
    )) }
     
      {/* <tr>
        <th scope="row">Gas Power</th>
        <td>7KW</td>
      </tr>
      <tr>
        <th scope="row">Dim</th>
        <td>400×700×250 Mm</td>
      </tr>
      <tr>
        <th scope="row">Brand</th>
        <td>Zanussi</td>
      </tr>
      <tr>
        <th scope="row">Origin</th>
        <td>Italy</td>
      </tr> */}

    </tbody>
  </table>

  </div>
  </div>

  </div>
  <div class="tab-pane container fade" id="menu1"> 
    {reviews.length ? <></> : ' Nobody reviewed Buy and Be the First to review'}
    {
      reviews?.map((item,index) => (
        <div class="review-box mb-2" key={index}>
             <div class="author-box d-flex w-100">

               <div class="author-image">

                 <img src={`${Baseurl}/view/imageupload/${item?.userId?.img}`}/>

               </div>
               <div class="author-details">
                 <span class="author-name">
                   {item?.userId?.firstname} {item?.userId?.lastname }
                 </span>
                 <div class="author-designation">
                {new Date(item?.createdAt)?.toLocaleString()}
                 </div>
               </div>

             </div>
             <div className='mt-2 mb-3'>

<span class="ratings mb-2 mt-1">

{[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item?.rating || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))}     
{`${Number.isInteger(item?.rating) ? item?.rating + '.0' : item?.rating}`}


</span>   
</div>

               <h4 class="mt-2">{item?.headline || 'Only Star Rating'}</h4>


               <p>{item?.reviewText || 'Not yet described Only star rating'} </p>


             </div>
      ))
    }



  {/* end */}
  </div>
  <div class="tab-pane container fade" id="menu2">...</div>
</div>
          </div>


       <div className='widget-block'> 
        <div className='row'>
          <div className='col-sm-12'>
            <div className='fs-2'>
              <h3>Related Poducts</h3>
            </div>
            {/* <div className='d-flex gap-3 flex-wrap  justify-content-center  align-items-center pb-3'>
  {
    related?.map((item,index) => {
      return (
     <div key={item._id}>
      <div className="card" style={{width: '15rem',height:'19rem'}}>
  <button className="" onClick={()=>detailPage(item._id,item.category?.name)}>
      <div><img style={{width:'138px', height:'150px',borderRadius:'5px'}} src={`${Baseurl}/view/imageupload/${item.img}`} /></div>
    { item.type === 'old' ?<div className='border text-center p-1 bg-info'>OLD</div> :''}
    { item.type === 'refurb' ?<div className='border text-center p-1 bg-danger'>REFURBMISHED</div> :''}
    { item.type === 'brandnew' ?<div className='border text-center p-1 bg-success'>BRAND NEW</div> :''}
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center pb-1 text-nowrap bg-light w-100'>{item.brand.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center  text-nowrap bg-light w-100 d-flex justify-content-center gap-1'>
    <span><del>{item.mrprice}</del></span> <span>{item.ourprice}</span></div> 

  </button>
</div>
        </div>
      )
    })
  }
</div> */}

<div class="row">
 
 

  {related?.map((item,index) => {
    return (
      <div class="col-md-3" key={index}>
      <button className="" onClick={()=>detailPage(item._id)}>
      <div class="product-box" >

<div class="project-image">

  <img src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`} class="img-fluid"  />

</div>

<div class="product-details">
  <h4>
    {item?.name}
  </h4>
<div>              <span class="price">AED {item?.ourprice}</span> <span class="crossed-price">AED {item?.mrpprice}</span>
</div>
<div class="ratings mb-2 mt-1">
{[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item?.averageRating || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))}     
{`${Number.isInteger(item?.averageRating) ? item?.averageRating + '.0' : item?.averageRating}`}
</div>
</div>
</div> </button> </div>
    )
  })}

</div>
          </div>
        </div></div>
       

      {/* <Tempfooter /> */}

        {/* <div className='row text-center'>
          <div className='col-sm-3 pb-3'>
          <p>Footer portion</p>
          </div>
        </div> */}

      </div>
      </section>
      <Tempfooter phoneNumber={setWhatsaapNumber} />
      </main>
     
    </>
  )
}

export default Details
